import * as React from "react";
const SvgBeaker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M49.428 45.428a2 2 0 0 0-1.022-.547l-2.387-.477a6 6 0 0 0-3.86.517l-.318.158a6 6 0 0 1-3.86.517l-1.931-.386a2 2 0 0 0-1.806.547M38 34h8l-1 1v5.172a2 2 0 0 0 .586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H34.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 0 0 39 40.172V35z"
    />
  </svg>
);
export default SvgBeaker;
